import { ChartNoAxesCombined } from 'lucide-react';

function DashboardEmptyState({
  message = 'No data available yet.',
  compact = false,
}) {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center text-[var(--theme-text-muted)] ${
        compact ? 'py-3' : 'px-6 py-12'
      }`}
    >
      <div className="grid h-14 w-14 place-items-center rounded-full bg-[var(--theme-accent-soft)] text-[var(--theme-text-muted)]">
        <ChartNoAxesCombined className="h-6 w-6" aria-hidden="true" />
      </div>
      <p className="m-0 mt-4 max-w-[18rem] text-[0.92rem] leading-6">{message}</p>
    </div>
  );
}

export default DashboardEmptyState;
